import { Typography } from '@mui/material';
import { useCustomDashboardContext } from 'src/contexts/customDashboardContext/customDashboard.context';

export const PreviewDashboardTitle = () => {
  const { title } = useCustomDashboardContext();
  return (
    <Typography variant="h4" component="h1" data-sm="title">
      {title}
    </Typography>
  );
};
